import { useEffect, useState } from 'react';
import { PawPrint } from 'lucide-react';
import { useI18n } from '../lib/i18n';

export default function LanguageGate() {
  const { setLanguage } = useI18n();
  const [open, setOpen] = useState(false);
  useEffect(() => { setOpen(!localStorage.getItem('pawtrait-language')); }, []);
  if (!open) return null;
  const choose = (lang: 'en' | 'pl') => { setLanguage(lang); setOpen(false); };
  return (
    <div className="language-gate" role="dialog" aria-modal="true">
      <div className="language-card">
        <PawPrint size={30} strokeWidth={1.5} />
        <div className="eyebrow">PAWTRAIT STUDIO</div>
        <h1>Choose your language</h1>
        <p>Wybierz język</p>
        <div className="language-actions">
          <button onClick={() => choose('pl')} className="language-option"><span>🇵🇱</span><strong>Polski</strong></button>
          <button onClick={() => choose('en')} className="language-option"><span>🇬🇧</span><strong>English</strong></button>
        </div>
      </div>
    </div>
  );
}
